import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user
  const [ready, setReady] = useState(false);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => setReady(true));
  // run exactly once on mount; api/setters are stable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const value = useMemo(() => {
    const login = async (email, password) => {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      return data;
    };
    const register = async (email, password, name) => {
      const { data } = await api.post("/auth/register", { email, password, name });
      setUser(data);
      return data;
    };
    const logout = async () => {
      await api.post("/auth/logout");
      setUser(false);
    };
    const refresh = async () => {
      try {
        const r = await api.get("/auth/me");
        setUser(r.data);
        return r.data;
      } catch {
        setUser(false);
        return null;
      }
    };
    return { user, ready, login, register, logout, refresh };
  }, [user, ready]);

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
